import React, { useState } from 'react'
import styled from 'styled-components'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { ParameterGroupFiltersFormModel } from 'modules/collection-performance/components/parameter-group/filters-parameter-group/inner/ParameterGroupFiltersFormModel'
import { FiltersParameterGroupCP } from 'modules/collection-performance/components/parameter-group/filters-parameter-group/FiltersParameterGroupCP'
import { TableParameterGroupCP } from 'modules/collection-performance/components/parameter-group/table-parameter-group/TableParameterGroupCP'
import { ButtonModalParameterGroupCP } from 'modules/collection-performance/components/parameter-group/button-modal-parameter-group/ButtonModalParameterGroupCP'

/**
 * Aba de administracao de Grupos de Parametros na Tela 3.1.
 */
export function TabParameterGroupCP(): JSX.Element {

    const [formModel] = useState<ParameterGroupFiltersFormModel>(new ParameterGroupFiltersFormModel())
    const formStateManager = useFormStateManager(formModel)

    const [shouldLoadData, setShouldLoadData] = useState<number>(TableUtils.getReloadNumber())

    return (
        <>
            <TopBarSCP>
                <ButtonGroupCP mode={'separeted'}>
                    <ButtonModalParameterGroupCP onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}/>
                </ButtonGroupCP>
            </TopBarSCP>

            <FiltersParameterGroupCP
                formStateManager={formStateManager}
                onFilter={() => setShouldLoadData(TableUtils.getReloadNumber())}
            />

            <TableParameterGroupCP
                filters={ParameterGroupFiltersFormModel.formatDto(formStateManager)}
                shouldLoadData={shouldLoadData}
            />
        </>
    )
}

const TopBarSCP = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
`
